import { writable } from 'svelte/store';

export const timelineZoomState = writable(30);